import React, { useEffect, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { Link } from 'react-router-dom';
import './estilos.css';

  const DetalleDIFMunicipales = () => {

        useEffect(() => {
          window.scrollTo(0, 0);
    },[]);

      const { useState } = React;
  //    const { render } = ReactDOM;

      const [isPopupOpen1, setPopupOpen1] = useState(false);
      const openPopup1 = () => { setPopupOpen1(true); };
      const closePopup1 = () => { setPopupOpen1(false); };

      const [isPopupOpen2, setPopupOpen2] = useState(false);
      const openPopup2 = () => { setPopupOpen2(true); };
      const closePopup2 = () => { setPopupOpen2(false); };

      const [isPopupOpen3, setPopupOpen3] = useState(false);
      const openPopup3 = () => { setPopupOpen3(true); };
      const closePopup3 = () => { setPopupOpen3(false); };

      const [isPopupOpen4, setPopupOpen4] = useState(false);
      const openPopup4 = () => { setPopupOpen4(true); };
      const closePopup4 = () => { setPopupOpen4(false); };

      const [isPopupOpen5, setPopupOpen5] = useState(false);
      const openPopup5 = () => { setPopupOpen5(true); };
      const closePopup5 = () => { setPopupOpen5(false); };

      const [isPopupOpen6, setPopupOpen6] = useState(false);
      const openPopup6 = () => { setPopupOpen6(true); };
      const closePopup6 = () => { setPopupOpen6(false); };

      const [isPopupOpen7, setPopupOpen7] = useState(false);
      const openPopup7 = () => { setPopupOpen7(true); };
      const closePopup7 = () => { setPopupOpen7(false); };

      const [isPopupOpen8, setPopupOpen8] = useState(false);
      const openPopup8 = () => { setPopupOpen8(true); };
      const closePopup8 = () => { setPopupOpen8(false); };

      const [isPopupOpen9, setPopupOpen9] = useState(false);
      const openPopup9 = () => { setPopupOpen9(true); };
      const closePopup9 = () => { setPopupOpen9(false); };

      const [isPopupOpen10, setPopupOpen10] = useState(false);
      const openPopup10 = () => { setPopupOpen10(true); };
      const closePopup10 = () => { setPopupOpen10(false); };


   // const acordeon = document.getElementsByClassName('contenedor');
     //   let i;
     //   for (i=0; i<acordeon.length; i++) {
     //   acordeon[i].addEventListener('click', function () {
     //   this.classList.toggle('activa');
     //   });
     // }


  return (
    <div className="container">{/* */}
      <div className="row">
            <div className="ldf_titulo">
                <h2>DIF Municipales</h2>
                <hr className="hr-gob" />
            </div>
  
          <div className="acordeon-cuerpo">
                <div className="acordeon"> 
                    <h3>Menú de accesos y descarga de Formatos</h3>

                    <Accordion>
                        <Accordion.Item eventKey="0">
                           <Accordion.Header><p className="estiloItemsAcordeon">SIEB</p></Accordion.Header>
                           <Accordion.Body>
                        
                              <table className="table table-striped acordeonTabla">
                                    <tbody>
                                      <tr>
                                        <td><div className="acordeonItems"><i className="bi bi-file-earmark-person-fill"></i></div></td>
                                        <td colspan="2"><div><a href="https://sistemas.dif.hidalgo.gob.mx/sieb/acceso.aspx?ReturnUrl=%2fsieb%2f" target="_blank" rel="noopener noreferrer">Acceso al Sistema de Información Estadística de Beneficiarios (SIEB)</a></div></td>
                                      </tr>
                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                        <td>Procedimiento Actualización de Usuarios SIEB</td>
                                        <td>
                                            <div>
                                                <a href="http://dif.hidalgo.gob.mx/dif_municipales/sieb/Procedimiento_Actualizacion_de_Usuarios_SIEB.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                            </div>
                                          </td>
                                      </tr>
                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                        <td><div>Formato Alta de Usuario</div></td>
                                        <td>
                                            <div>
                                                <a href="../dif_municipales/sieb/Cedula_Alta_de_usuario_Sistema_SIEB_mun.docx" download target="_blank"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                            </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                        <td><div>Formato Modificación de Usuario</div></td>
                                        <td>
                                            <div>
                                                <a href="../dif_municipales/sieb/Cedula_Modificacion_de_usuario_Sistema_SIEB_mun.docx" download target="_blank"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                            </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                        <td><div>Formato Ratificación de Usuario</div></td>
                                        <td>
                                            <div>
                                                <a href="../dif_municipales/sieb/Cedula_Ratificacion_de_usuario_Sistema_SIEB_mun.docx" download target="_blank"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                            </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                        <td><div>Formato Baja de Usuario</div></td>
                                        <td>
                                            <div>
                                                <a href="../dif_municipales/sieb/Cedula_Baja_de_usuario_Sistema_SIEB_mun.docx" download target="_blank"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                            </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td colspan="3"><p>Material de Apoyo a Usuarios</p></td>
                                      </tr>
                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                        <td>Manual de usuario</td>
                                        <td>
                                            <div>
                                                <a href="http://dif.hidalgo.gob.mx/dif_municipales/sieb/Manual_usuario_sieb_convertido.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                            </div>
                                          </td>
                                      </tr>
                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                        <td>Manual de usuario - Acceso a SIEB en dos pasos</td>
                                        <td>
                                            <div>
                                                <a href="http://dif.hidalgo.gob.mx/dif_municipales/sieb/SIEB_manual_usuario_acceso_en_dos_pasos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                            </div>
                                          </td>
                                      </tr>
                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                        <td>Manual de usuario (Padrones)</td>
                                        <td>
                                            <div>
                                                <a href="http://dif.hidalgo.gob.mx/dif_municipales/sieb/SIEB_manual_usuario_padrones.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                            </div>
                                          </td>
                                      </tr> 
                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                        <td>Manual CAIC</td>
                                        <td>
                                            <div>
                                                <a href="http://dif.hidalgo.gob.mx/dif_municipales/sieb/Manual_CAIC_v1.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                            </div>
                                          </td>
                                      </tr>
                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                        <td>Presentación SIEB</td>
                                        <td>
                                            <div>
                                                <a href="http://dif.hidalgo.gob.mx/dif_municipales/sieb/Presentacion_SIEB_convertido.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                            </div>
                                          </td>
                                      </tr>
                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                        <td>Directorio de Enlaces para los Programas de Desayunos Escolares Frios, Calientes y EAEYD</td>
                                        <td>
                                            <div>
                                                <a href="http://dif.hidalgo.gob.mx/dif_municipales/sieb/DIRECTORIO_DE_ENLACES_PARA_LOS_PROGRAMAS_DESAYUNOS_ESCOLARES_FRIO_CALIENTE_Y_EAEYD.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                            </div>
                                          </td>
                                      </tr>
                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                        <td>Proceso de Registro y Actualización de SEPH</td>
                                        <td>
                                            <div>
                                                <a href="http://dif.hidalgo.gob.mx/dif_municipales/sieb/PROCESO_DE_REGISTRO_Y_ACTUALIZACIÓN_DE_BENEFICIARIOS_SEPH-PROGRAMAS ALIMENTARIOS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                            </div>
                                          </td>
                                      </tr>
                                      <tr>
                                        <td colspan="3"><p>NOTA IMPORTANTE: DEBERÁ COORDINARSE CON SU ENLACE DEL SISTEMA DIF HIDALGO PARA PROGRAMAR LA CAPACITACIÓN DE USUARIOS NUEVOS.</p></td>
                                      </tr>
                                    

                                      <tr>
                                        <td colspan="3"><p>Material Audiovisual (video-tutoriales)</p></td>
                                      </tr>

                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-play-fill"></i></div></td>
                                        <td>Este invierno abrígalo</td>
                                        <td>
                                           <button className="btn btn-default btn-acordeon" onClick={openPopup10}>MP4</button>
                                              
                                              {isPopupOpen10 && (
                                                 <div className="modal-overlay">
                                                   <div id="modal10" className="ventana-popupSIEB"> 
                                                            <div className="modal-header">
                                                               <h5 style={{ color: "white" }}><span>Este invierno abrígalo</span></h5>
                                                               <button type="button" className="btn-cerrarSIEB" data-bs-target="#modal10" data-dismiss="modal" aria-label="Close" onClick={closePopup10}>
                                                                  <span aria-hidden="true">X</span>
                                                               </button>
                                                            </div>
                                                           <div className="modal-body">
                                                                <video style={{ height: "600px" }} controls>
                                                                       <source src="http://dif.hidalgo.gob.mx/dif_municipales/sieb/EsteInviernoAbrigalo.mp4" type="video/mp4"/>
                                                                </video>
                                                           </div>
                                                           <div className="modal-footer">
                                                                <button type="button" className="btnCerrarGold" onClick={closePopup10}>cerrar</button>
                                                          </div>
                                                   </div>
                                                 </div> 
                                                )}
                                        </td>
                                    </tr>

                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-play-fill"></i></div></td>
                                        <td>Acceso al sistema SIEB</td>
                                        <td>
                                           <button className="btn btn-default btn-acordeon" onClick={openPopup1}>MP4</button>
                                              
                                              {isPopupOpen1 && (
                                                 <div className="modal-overlay">
                                                   <div id="modal1" className="ventana-popupSIEB"> 
                                                            <div className="modal-header">
                                                               <h5 style={{ color: "white" }}><span>Acceso al sistema SIEB</span></h5>
                                                               <button type="button" className="btn-cerrarSIEB" data-bs-target="#modal1" data-dismiss="modal" aria-label="Close" onClick={closePopup1}>
                                                                  <span aria-hidden="true">X</span>
                                                               </button>
                                                            </div>
                                                           <div className="modal-body">
                                                                <video style={{ height: "600px" }} controls>
                                                                       <source src="http://dif.hidalgo.gob.mx/dif_municipales/sieb/acceso_sieb.mp4" type="video/mp4"/>
                                                                </video>
                                                           </div>
                                                           <div className="modal-footer">
                                                                <button type="button" className="btnCerrarGold" onClick={closePopup1}>cerrar</button>
                                                          </div>
                                                   </div>
                                                 </div> 
                                                )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><div><i className="bi bi-file-earmark-play-fill"></i></div></td>
                                        <td>Acceso al sistema SIEB en dos pasos</td>
                                        <td>
                                            <button className="btn btn-default btn-acordeon" onClick={openPopup2}>MP4</button>
                                              
                                              {isPopupOpen2 && (
                                                 <div className="modal-overlay">
                                                   <div id="modal2" className="ventana-popupSIEB"> 
                                                            <div className="modal-header">
                                                               <h5 style={{ color: "white" }}><span>Acceso al sistema SIEB en dos pasos</span></h5>
                                                               <button type="button" className="btn-cerrarSIEB" data-bs-target="#modal2" data-dismiss="modal" aria-label="Close" onClick={closePopup2}>
                                                                <span aria-hidden="true">X</span>
                                                               </button>
                                                            </div>
                                                           <div className="modal-body">
                                                                <video style={{ height: "600px" }} controls>
                                                                       <source src="http://dif.hidalgo.gob.mx/dif_municipales/sieb/SIEB_Videotutorial_acceso_en_dos_pasos.mp4" type="video/mp4"/>
                                                                </video>
                                                           </div>
                                                           <div className="modal-footer">
                                                                <button type="button" className="btnCerrarGold" onClick={closePopup2}>cerrar</button>
                                                          </div>
                                                   </div>
                                                 </div> 
                                                )}
                                        </td>
                                    </tr>  


                                     <tr>
                                        <td><div><i className="bi bi-file-earmark-play-fill"></i></div></td>
                                        <td>Actualización y alta de datos de beneficiarios (apoyos escolares alimentarios)</td>
                                        <td>
                                           <button className="btn btn-default btn-acordeon" onClick={openPopup3}>MP4</button>
                                              
                                              {isPopupOpen3 && (
                                                 <div className="modal-overlay">
                                                   <div id="modal3" className="ventana-popupSIEB"> 
                                                            <div className="modal-header">
                                                               <h5 style={{ color: "white" }}><span>Actualización y alta de datos</span></h5>
                                                               <button type="button" className="btn-cerrarSIEB" data-bs-target="#modal3" data-dismiss="modal" aria-label="Close" onClick={closePopup3}>
                                                                  <span aria-hidden="true">X</span>
                                                               </button>
                                                            </div>
                                                           <div className="modal-body">
                                                                <video style={{ height: "600px" }} controls>
                                                                       <source src="http://dif.hidalgo.gob.mx/dif_municipales/sieb/actualizacion_alta_usuarios.mp4" type="video/mp4"/>
                                                                </video>
                                                           </div>
                                                           <div className="modal-footer">
                                                                <button type="button" className="btnGaleria" onClick={closePopup3}>cerrar</button>
                                                          </div>
                                                    </div>
                                                  </div> 
                                                )}
                                        </td>
                                      </tr>  

                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-play-fill"></i></div></td>
                                        <td>Alta de Beneficiario</td>
                                        <td>
                                           <button className="btn btn-default btn-acordeon" onClick={openPopup4}>MP4</button>
                                              
                                              {isPopupOpen4 && (
                                                 <div className="modal-overlay">
                                                   <div id="modal4" className="ventana-popupSIEB"> 
                                                            <div className="modal-header">
                                                               <h5 style={{ color: "white" }}><span>Alta de Beneficiario</span></h5>
                                                               <button type="button" className="btn-cerrarSIEB" data-bs-target="#modal4" data-dismiss="modal" aria-label="Close" onClick={closePopup4}>
                                                                  <span aria-hidden="true">X</span>
                                                               </button>
                                                            </div>
                                                           <div className="modal-body">
                                                                <video style={{ height: "600px" }} controls>
                                                                       <source src="http://dif.hidalgo.gob.mx/dif_municipales/sieb/alta_beneficiario.mp4" type="video/mp4"/>
                                                                </video>
                                                           </div>
                                                           <div className="modal-footer">
                                                                <button type="button" className="btnGaleria" onClick={closePopup4}>cerrar</button>
                                                          </div>
                                                    </div>
                                                  </div> 
                                                )}
                                        </td>
                                      </tr>  

                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-play-fill"></i></div></td>
                                        <td>Alta de apoyo general</td>
                                        <td>
                                           <button className="btn btn-default btn-acordeon" onClick={openPopup5}>MP4</button>
                                              
                                              {isPopupOpen5 && (
                                                 <div className="modal-overlay">
                                                   <div id="modal5" className="ventana-popupSIEB"> 
                                                            <div className="modal-header">
                                                               <h5 style={{ color: "white" }}><span>Alta de apoyo general</span></h5>
                                                               <button type="button" className="btn-cerrarSIEB" data-bs-target="#modal5" data-dismiss="modal" aria-label="Close" onClick={closePopup5}>
                                                                  <span aria-hidden="true">X</span>
                                                               </button>
                                                            </div>
                                                           <div className="modal-body">
                                                                <video style={{ height: "600px" }} controls>
                                                                       <source src="http://dif.hidalgo.gob.mx/dif_municipales/sieb/alta_de_apoyo_general.mp4" type="video/mp4"/>
                                                                </video>
                                                           </div>
                                                           <div className="modal-footer">
                                                                <button type="button" className="btnGaleria" onClick={closePopup5}>cerrar</button>
                                                          </div>
                                                    </div>
                                                  </div> 
                                                )}
                                        </td>
                                      </tr>  

                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-play-fill"></i></div></td>
                                        <td>Asignación de apoyos escolares alimentarios</td>
                                        <td>
                                           <button className="btn btn-default btn-acordeon" onClick={openPopup6}>MP4</button>
                                              
                                              {isPopupOpen6 && (
                                                 <div className="modal-overlay">
                                                   <div id="modal6" className="ventana-popupSIEB"> 
                                                            <div className="modal-header">
                                                               <h5 style={{ color: "white" }}><span>Asignación de apoyos escolares alimentarios</span></h5>
                                                               <button type="button" className="btn-cerrarSIEB" data-bs-target="#modal6" data-dismiss="modal" aria-label="Close" onClick={closePopup6}>
                                                                  <span aria-hidden="true">X</span>
                                                               </button>
                                                            </div>
                                                           <div className="modal-body">
                                                                <video style={{ height: "600px" }} controls>
                                                                       <source src="http://dif.hidalgo.gob.mx/dif_municipales/sieb/asignacion_apoyos_escolares_alimentarios.mp4" type="video/mp4"/>
                                                                </video>
                                                           </div>
                                                           <div className="modal-footer">
                                                                <button type="button" className="btnGaleria" onClick={closePopup6}>cerrar</button>
                                                          </div>
                                                    </div>
                                                  </div> 
                                                )}
                                        </td>
                                      </tr>  

                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-play-fill"></i></div></td>
                                        <td>Eliminar un apoyo de un Beneficario</td>
                                        <td>
                                           <button className="btn btn-default btn-acordeon" onClick={openPopup7}>MP4</button>
                                              
                                              {isPopupOpen7 && (
                                                 <div className="modal-overlay">
                                                   <div id="modal7" className="ventana-popupSIEB"> 
                                                            <div className="modal-header">
                                                               <h5 style={{ color: "white" }}><span>Eliminar un apoyo de un Beneficario</span></h5>
                                                               <button type="button" className="btn-cerrarSIEB" data-bs-target="#modal7" data-dismiss="modal" aria-label="Close" onClick={closePopup7}>
                                                                  <span aria-hidden="true">X</span>
                                                               </button>
                                                            </div>
                                                           <div className="modal-body">
                                                                <video style={{ height: "600px" }} controls>
                                                                       <source src="http://dif.hidalgo.gob.mx/dif_municipales/sieb/eliminar_un_apoyo.mp4" type="video/mp4"/>
                                                                </video>
                                                           </div>
                                                           <div className="modal-footer">
                                                                <button type="button" className="btnGaleria" onClick={closePopup7}>cerrar</button>
                                                          </div>
                                                    </div>
                                                  </div> 
                                                )}
                                        </td>
                                      </tr>  

                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-play-fill"></i></div></td>
                                        <td>Generar un reporte alimentario</td>
                                        <td>
                                           <button className="btn btn-default btn-acordeon" onClick={openPopup8}>MP4</button>
                                              
                                              {isPopupOpen8 && (
                                                 <div className="modal-overlay">
                                                   <div id="modal8" className="ventana-popupSIEB"> 
                                                            <div className="modal-header">
                                                               <h5 style={{ color: "white" }}><span>Generar un reporte alimentario</span></h5>
                                                               <button type="button" className="btn-cerrarSIEB" data-bs-target="#modal8" data-dismiss="modal" aria-label="Close" onClick={closePopup8}>
                                                                  <span aria-hidden="true">X</span>
                                                               </button>
                                                            </div>
                                                           <div className="modal-body">
                                                                <video style={{ height: "600px" }} controls>
                                                                       <source src="http://dif.hidalgo.gob.mx/dif_municipales/sieb/reporte_alimentario.mp4" type="video/mp4"/>
                                                                </video>
                                                           </div>
                                                           <div className="modal-footer">
                                                                <button type="button" className="btnGaleria" onClick={closePopup8}>cerrar</button>
                                                          </div>
                                                    </div>
                                                  </div> 
                                                )}
                                        </td>
                                      </tr>  

                                      <tr>
                                        <td><div><i className="bi bi-file-earmark-play-fill"></i></div></td>
                                        <td>Generar un reporte general</td>
                                        <td>
                                           <button className="btn btn-default btn-acordeon" onClick={openPopup9}>MP4</button>
                                              
                                              {isPopupOpen9 && (
                                                 <div className="modal-overlay">
                                                   <div id="modal9" className="ventana-popupSIEB"> 
                                                            <div className="modal-header">
                                                               <h5 style={{ color: "white" }}><span>Generar un reporte general</span></h5>
                                                               <button type="button" className="btn-cerrarSIEB" data-bs-target="#modal9" data-dismiss="modal" aria-label="Close" onClick={closePopup9}>
                                                                  <span aria-hidden="true">X</span>
                                                               </button>
                                                            </div>
                                                           <div className="modal-body">
                                                                <video style={{ height: "600px" }} controls>
                                                                       <source src="http://dif.hidalgo.gob.mx/dif_municipales/sieb/reporte_general.mp4" type="video/mp4"/>
                                                                </video>
                                                           </div>
                                                           <div className="modal-footer">
                                                                <button type="button" className="btnGaleria" onClick={closePopup9}>cerrar</button>
                                                          </div>
                                                    </div>
                                                  </div> 
                                                )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td><div><i className="fbi bi-file-earmark-play-fill"></i></div></td>
                                        <td>Registro de Tutor para beneficiarios menores de edad</td>
                                        <td>
                                           <a href="https://dif.hidalgo.gob.mx/dif_municipales/sieb/Registro_de_Tutor_para_Beneficiarios_menores_de_edad.mp4" target="_blank" rel="noopener noreferrer">
                                           <button className="btn btn-default btn-acordeon">MP4</button></a>
                                        </td>
                                      </tr>   
                                 </tbody>
                              </table>
                          </Accordion.Body>
                      </Accordion.Item>

                    <Accordion.Item eventKey="1">
                        <Accordion.Header><p className="estiloItemsAcordeon">Asistencia Social</p></Accordion.Header>
                        <Accordion.Body>
                      
                          <table className="table table-striped acordeonTabla">
                            <tbody>
                              <tr>
                                <td colspan="3"><p>Ayuda en Especie a Desamparados</p></td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                <td>Requisitos Programa Ayuda en Especie a Desamparados</td>
                                <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/dif_municipales/asistencia/Requisitos_Ayuda_en_Especie_a_Desamparados.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                    </div>
                                </td>
                              </tr>

                              <tr>
                                <td colspan="3"><p>Calidad de Vida en Personas Adultas Mayores</p></td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-excel-fill"></i></div></td>
                                <td>F01 Plantilla Inicial</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/asistencia/F01_Planilla_inicial.xlsx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">XLSX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-excel-fill"></i></div></td>
                                <td>F02 Estudio Socioeconómico</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/asistencia/F02_Estudio_socioeconomico.xlsx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">XLSX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-excel-fill"></i></div></td>
                                <td>F03 Lista de Asistencia</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/asistencia/F03_Lista_de_asistencia.xlsx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">XLSX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-excel-fill"></i></div></td>
                                <td>F04 Bitácora de Actividades Mensuales</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/asistencia/F04_Bitacora_de_actividades_mensuales.xlsx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">XLSX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-excel-fill"></i></div></td>
                                <td>F05 Cédula de Grupo</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/asistencia/F05_Cedula_de_grupo.xlsx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">XLSX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                <td>FCR Solicitud de Campamento Recreativo</td>
                                <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/dif_municipales/asistencia/FCR_Solicitud_para_Campamento_Recreativo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                <td>FN Formato para Nombramiento</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/asistencia/FN_Formato_para_nombramiento.docx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                    </div>
                                </td>
                              </tr>

                              <tr>
                                <td colspan="3"><p>Jornadas Médicas de Subespecialidad</p></td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                <td>Carta Petición 2023</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/asistencia/1_Carta_Peticion_2023.docx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                <td>Estudio Socioeconómico 2023</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/asistencia/2_Estudio_Socioeconomico_2023.docx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                <td>Carta Autorización Adulto</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/asistencia/3_Carta_Autorizacion_adulto.docx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                <td>Carta de Autorización Menor de Edad</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/asistencia/3_Carta_Autorizacion_menor_de_edad.docx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                <td>Carta Responsiva 2023</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/asistencia/4_Carta_Responsiva_2023.docx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-excel-fill"></i></div></td>
                                <td>Registro de Solicitantes</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/asistencia/5_Registro_de_Solicitantes.xlsx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">XLSX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-excel-fill"></i></div></td>
                                <td>Registro de Población con Cirugía Extramuros que Mejoraron su Salud 2023</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/asistencia/6_Registro_de_Poblacion_con_Cirugia_Extramuros_que_mejoraron_su_salud_2023.xlsx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">XLSX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                <td>Encuesta de Satisfacción 2023</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/asistencia/7_Encuesta_de_Satisfaccion_2023.docx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                    </div>
                                </td>
                              </tr>
                            </tbody>
                        </table>
                    </Accordion.Body>
                </Accordion.Item>

                    <Accordion.Item eventKey="2">
                        <Accordion.Header><p className="estiloItemsAcordeon">Alimentarios</p></Accordion.Header>
                        <Accordion.Body>
                       
                          <table className="table table-striped acordeonTabla">
                            <tbody>
                              <tr>
                                <td colspan="3"><p>Plataforma de Capacitación para Usuarios SMDIF</p></td>
                              </tr>
                              <tr>
                                <td><div className="acordeonItems"><i className="bi bi-file-earmark-person-fill"></i></div></td>
                                <td colspan="2"><div><a href="https://sites.google.com/view/capacitacin-programas-alimenta/daydc" target="_blank" rel="noopener noreferrer">Acceso a la plataforma</a></div></td>
                              </tr>

                              <tr>
                                <td colspan="3"><p>Asistencia Social Alimentaria a Personas con Atención Prioritaria, Adultos Mayores y Personas con Discapacidad</p></td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                <td>Acta de Integración de Comité Comunitario de Participación Social</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/alimentarios/Acta_de_Integracion_de_Comite_Comunitario_de_Participacion_Social.docx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-excel-fill"></i></div></td>
                                <td>Evidencia Fotográfica Entraga de Dotaciones</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/alimentarios/Evidencia_Fotografica_Entrega_de_Dotaciones.xlsx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">XLSX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-excel-fill"></i></div></td>
                                <td>Reporte Mensual de Distribución</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/alimentarios/Reporte_mensual_de_distribucion.xlsx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">XLSX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-excel-fill"></i></div></td>
                                <td>Validación de Entrega de Dotaciones</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/alimentarios/Validación_de_Entrega_de_Dotaciones.xlsx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">XLSX</button></a>
                                    </div>
                                </td>
                              </tr>

                              <tr>
                                <td colspan="3"><p>Asistencia Social Alimentaria en los Primeros 1000 Días de Vida</p></td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                <td>Acta de Integración de Comité Comunitario de Participación Social</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/alimentarios/Acta_de_Integracion_de_Comite_Comunitario_de_Participacion_Social_1000dias.docx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                <td>Cédula de Seguimiento a Comités Comunitarios de Participación Social</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/alimentarios/Cédula_de_seguimiento_a_Comites_Comunitarios_de_Participación_Social.docx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-excel-fill"></i></div></td>
                                <td>Información de Municipios</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/alimentarios/Informacion_Municipios.xlsx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">XLSX</button></a>
                                    </div>
                                </td>
                              </tr>

                              <tr>
                                <td colspan="3"><p>Asistencia Social Alimentaria a Personas en Situación de Emergencia o Desastre</p></td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                <td>Cédula de Beneficiarios SIEB</td>
                                <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/dif_municipales/alimentarios/CEDULA_DE_BENEFICIARIOS_SIEB.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                    </div>
                                  </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                <td>Reporte de Distribución</td>
                                <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/dif_municipales/alimentarios/Reporte_de_distribucion.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                    </div>
                                  </td>
                              </tr>

                              <tr>
                                <td colspan="3"><p>Atención a Población en Condiciones de Emergencia o Desastre</p></td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                <td>Acta Constitutiva de Subcomité Municipal</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/alimentarios/Acta_constitutiva_del_Subcomite_Municipal_2023.docx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                <td>Formato de Registro Centro de Acopio</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/alimentarios/Formato_Registro_Centro_de_Acopio.docx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                <td>Formato Registro Refugios Temporales</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/alimentarios/Formato_Registro_Refugios_Temporales.docx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                <td>Guía Atención a Población en Condiciones de Emergencia</td>
                                <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/dif_municipales/alimentarios/Guia_Atencion_a_Poblacion_en_Condiciones_de_Emergencia.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-excel-fill"></i></div></td>
                                <td>Reporte Acciones APCE Mensual</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/alimentarios/Reporte_Acciones_APCE_mensual.xlsx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">XLSX</button></a>
                                    </div>
                                </td>
                              </tr>

                              <tr>
                                <td colspan="3"><p>Espacios de Alimentación Encuentro y Desarrollo</p></td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                <td>Acta de Integración de Comité Comunitario de Participación Social</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/alimentarios/Acta_de_Integracion_de_Comite_Comunitario_de_Participacion_Social_EAEyD.docx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-word-fill"></i></div></td>
                                <td>Cédula de Seguimiento a Comités Comunitarios de Participación Social</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/alimentarios/Cedula_de_seguimiento_a_comites_Comunitarios_de_Participacion_Social_EAEyD.docx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">DOCX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-excel-fill"></i></div></td>
                                <td>Información de Municipios</td>
                                <td>
                                    <div>
                                        <a href="../dif_municipales/alimentarios/Informacion_de_Municipios_EAEyD.xlsx" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">XLSX</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                <td>Rotulo</td>
                                <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/dif_municipales/alimentarios/Rotulo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                    </div>
                                </td>
                              </tr>

                              <tr>
                                <td colspan="3"><p>Programa Salud y Bienestar Comunitario</p></td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                <td>Acta Constitutiva</td>
                                <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/dif_municipales/alimentarios/Acta_Constitutiva.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                <td>ROP PSBC 2023</td>
                                <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/dif_municipales/alimentarios/ROP_PSBC_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                    </div>
                                </td>
                              </tr>
                            </tbody>
                        </table>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="3">
                        <Accordion.Header><p className="estiloItemsAcordeon">Orientación y Educación Alimentaria</p></Accordion.Header>
                        <Accordion.Body>
                      
                        <table className="table table-striped acordeonTabla">
                            <tbody>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                <td>Díptico Alimentación Complementaria</td>
                                <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/dif_municipales/alimentarios/Díptico_Alimentación_Complementaria.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                <td>Infografías Alimentarias</td>
                                <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/dif_municipales/alimentarios/info-alimentarias.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                    </div>
                                </td>
                              </tr>
                            </tbody>
                        </table>
                    </Accordion.Body>
                </Accordion.Item>   
                    
                    <Accordion.Item eventKey="4">
                        <Accordion.Header><p className="estiloItemsAcordeon">Centro de Rehabilitación Integral Hidalgo (CRIH)</p></Accordion.Header>
                        <Accordion.Body>
                     
                        <table className="table table-striped acordeonTabla">
                            <tbody>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                <td>Requisitos Programa Ayudas Técnicas</td>
                                <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/dif_municipales/crih/Requisitos_Ayudas_Tecnicas.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                <td>Requisitos Programa Hacia una Vida Mejor</td>
                                <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/dif_municipales/crih/Requisitos_Hacia_una_Vida_Mejor.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                    </div>
                                </td>
                              </tr>
                            </tbody>
                        </table>
                    </Accordion.Body>
                </Accordion.Item> 
                    
                    <Accordion.Item eventKey="5">
                        <Accordion.Header><p className="estiloItemsAcordeon">Protección a la Niñez y Adolescencia</p></Accordion.Header>
                        <Accordion.Body>
                       
                        <table className="table table-striped acordeonTabla">
                            <tbody>
                              <tr>
                                <td><div><i className="bi bi-file-image-fill"></i></div></td>
                                <td>Logo Casa del Niño Sistema DIF Hidalgo</td>
                                <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/dif_municipales/proteccion/Logo_Casa_del_Niño_DIF.jpeg" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">IMG</button></a>
                                    </div>
                                </td>
                              </tr>
                            </tbody>
                        </table>
                    </Accordion.Body>
                </Accordion.Item>
                    
                    <Accordion.Item eventKey="6">
                        <Accordion.Header><p className="estiloItemsAcordeon">SEDE de Capacitación, Evaluación y Certificación de Competencias</p></Accordion.Header>
                        <Accordion.Body>
                     
                          <table className="table table-striped acordeonTabla">
                            <tbody>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                <td>Estándares de Competencia Laboral</td>
                                <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/dif_municipales/sede/Estandares_de_competencia.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                    </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                <td>Campus Virtual</td>
                                <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/dif_municipales/sede/Campus_virtual.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                    </div>
                                </td>
                              </tr>
                            </tbody>
                        </table>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                     
                  </div>
             </div>
       </div>
    </div>
)

}
 

export default DetalleDIFMunicipales